import React from 'react';

import {rootStore} from './rootStore';

const storesContext = React.createContext(rootStore);
export const useStores = () => React.useContext(storesContext);

// export const useStores = () => rootStore;
